import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ISpeech } from 'src/interfaces/speech.interface';

@Component({
  selector: 'app-search-speeches',
  templateUrl: './search-speeches.component.html',
  styleUrls: ['./search-speeches.component.css'],
})
export class SearchSpeechesComponent implements OnInit {
  speeches$: ISpeech[] = [];
  searchItems: ISpeech[] = [];
  searchKey: string = 'title';
  inputSearchKey: string = '';

  constructor(private store: Store<any>) {
    this.store.select('speech').subscribe((q) => {
      console.log(q);
      this.speeches$ = q.data;
    });
  }

  ngOnInit(): void {}

  onChange(event: any) {
    const a = this.speeches$.filter((q: any) => {
      return q[this.searchKey].toLowerCase().includes(event.target?.value);
    });
    this.inputSearchKey = event.target?.value;
    this.searchItems = a;
  }
}
